import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DateRangePicker } from 'react-date-range';
//import { CKEditor } from 'ckeditor4-react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import { Global } from '../services/Global';

import UploadIcon from '../assets/images/subir.png';
import WriteIcon from '../assets/images/redactar.png';
import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';

import ApiService from '../services/Api';
import { APIS } from '../services/Config';

// import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse( Tools.decryptrData( localStorage.getItem('app_fd') ) ) : {};

const mapStateToProps = (props) => { return {glo: props.general, pro: props.process} }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class PresentationLetterPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: (_fd.aditional_data !== null) ? _fd.aditional_data : FormFields.aditional_data,
            next_active: false,
            show_editor: false,
            has_file_s3: false,
            editor_max_words: 3000,
            editor_disable: false,
            file_selected: null,
            isFilePicked: false,
            selectionRange: {
                startDate: null,
                endDate: null,
                key: 'selection'
            },
            cartaPresentacion: '',
            maxLengthLetter: 30000,
            maxLengthLetterText: '0/30000',
            editorCK: null,
            itemFile: null
        }
    }

    componentDidMount() {
        let _root = this;
        if(!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            Tools.hidePreloader();
            _root.setState({
                program_selected: JSON.parse( Tools.decryptrData(localStorage.getItem('app_sp')) )
            });
            
            _root.onLoadLetter();
        }
    }
    
    onLoadLetter() {
        let _root = this;
        if( _root.props.pro.cartaPresentacion != '' ) {
            let _htmldata = _root.stripHtml(_root.props.pro.cartaPresentacion);
            let _cleandata = _htmldata.replace(/<\/?[^>]+(>|$)/g, "");
            _cleandata = _htmldata.replace(/(\r\n|\n|\r)/gm,"");
            _cleandata.replace(/(\r\n|\n|\r|\\n)/gm, '');
            _cleandata.trim();
            let _wordcount = (_cleandata).split(' ');
            _wordcount = _wordcount.filter(e => e !== '');
            // console.log(_wordcount);
            _root.setState({
                cartaPresentacion: _root.props.pro.cartaPresentacion,
                // maxLengthLetterText: `${_htmldata.length}/${_root.state.maxLengthLetter}`,
                maxLengthLetterText: `${_wordcount.length}/${_root.state.editor_max_words}`,
                show_editor: true,
                next_active: true,
                itemFile: null
            });
        }
        else {
            Tools.showPreloader();
            ApiService.getData(`${APIS.documentoByIdSubmission}${_root.props.pro.idSubmission}`)
            .then(res => {
                Tools.hidePreloader();
                for(let item of res.data) {
                    if(item.idTipo == '1') {
                        let _obj = {
                            name: item.nombreArchivo
                        };
                        _root.setState({
                            file_selected: _obj,
                            next_active: true,
                            has_file_s3: true,
                            itemFile: item
                        }, () => {
                            if( _root.props.pro.cartaPresentacion != '' ) {
                                _root.setState({
                                    show_editor: true
                                });
                            }
                        });
                    }
                }
            })
            .catch(err => { 
                Tools.hidePreloader();
                console.log(err); 
            });
        }
    }

    onChangeDateRange = (ranges) => {
        // console.log(ranges);
    }

    onChangeEditor = ( event ) => {
        let _root = this;
        // let data = editor.getData();
        let data = event.editor.getData();
        let _cleandata = data.replace(/<\/?[^>]+(>|$)/g, "");
        let _wordcount = (_cleandata).split(' ');
        // if(_wordcount.length >= _root.state.editor_max_words) {
        //     _root.setState({
        //         editor_disable: true
        //     });
        // }
        // else {
        //     _root.setState({
        //         editor_disable: false
        //     });
        // }
        if(_wordcount.length >= 0){
            // _root.props.pro.cartaPresentacion = data;
            let _htmldata = _root.stripHtml(data);
            if(_htmldata.length > 0) {
                // if(_htmldata.length <= _root.state.maxLengthLetter) {
                //     _root.setState({
                //         cartaPresentacion: data,
                //         next_active: true,
                //         maxLengthLetterText: `${_htmldata.length}/${_root.state.maxLengthLetter}`
                //     });
                // }
                // else {
                //     _root.setState({
                //         cartaPresentacion: _htmldata.substring(0, _root.state.maxLengthLetter),
                //         next_active: false
                //     }, () => {
                //         if(_root.state.editorCK !== null) {
                //             // _root.state.editorCK.editing.view.focus();
                //             console.log(_root.state.editorCK);
                //         }
                //     });
                // }
                if(_wordcount.length <= _root.state.editor_max_words) {
                    _root.setState({
                        cartaPresentacion: data,
                        next_active: true,
                        maxLengthLetterText: `${_wordcount.length}/${_root.state.editor_max_words}`
                    });
                }
                else {
                        _root.setState({
                            cartaPresentacion: _htmldata,
                            next_active: false
                        }, () => {
                            if(_root.state.editorCK !== null) {
                                // _root.state.editorCK.editing.view.focus();
                                // console.log(_root.state.editorCK);
                            }
                        });
                }
            }
        }
        
    }

    stripHtml(html){
        let doc = new DOMParser().parseFromString((html).replace('&nbsp;', ''), 'text/html');
        return doc.body.textContent || "";
    }

    onBlurEditor = ( event, editor ) => {

    }

    onFocusEditor = ( event, editor ) => {

    }
   
    changeHandlerInputFile = (event) => {
        let _root = this;
        var allowedExtensions = /(\.dot|\.docx|\.docx|\.pdf)$/i;
        _root.props.pro.cartaPresentacion = '';
        _root.setState({
            show_editor: false,
            cartaPresentacion: ''
        });
              
        if (!allowedExtensions.exec(event.target.files[0].name)) {
            alert('Formato no valido.');
            return;
        } 

        _root.setState({
            show_editor: false,
        }, () => {
            _root.setState({
                file_selected: event.target.files[0],
                isFilePicked: true,
                next_active: true
            }, () => {event.target.value = null;});
        });
        
        

	};

    deletFilePresentation = () => {
        let _root = this;

        Tools.showPreloader();
        if(_root.state.itemFile !== null) {
            ApiService.deleteData(`${APIS.documento}/${_root.state.itemFile.id}`)
            .then(res => {
                _root.setState({
                    show_editor: false,
                    file_selected: null,
                    isFilePicked: false,
                    next_active: false,
                    has_file_s3: false,
                    itemFile: null
                });
                Tools.hidePreloader();
            })
            .catch(err => {
                Tools.hidePreloader();
            });
        }
        else {
            _root.setState({
                show_editor: false,
                file_selected: null,
                isFilePicked: false,
                next_active: false
            });
            Tools.hidePreloader();
        }
    }

    onClickShowEditor = (e) => {
        e.preventDefault();

        let _root = this;

        _root.setState({
            show_editor: true,
            file_selected: null,
            isFilePicked: false,
            next_active: false
        });
    }

    onClickHideEditor = (e) => {
        e.preventDefault();

        let _root = this;
        _root.props.pro.cartaPresentacion = '';
        _root.setState({
            show_editor: false,
            next_active: false
        });
    }

    onClickDownloadLetter = (e) => {
        e.preventDefault();
        let _root = this;

        _root.onSaveData('download');
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        _root.onSaveData('next');
    }

    onSaveData(target) {
        let _root = this;

        Tools.showPreloader();
        var parser = new DOMParser();
        if(_root.state.cartaPresentacion != '') {
            var doc = parser.parseFromString((_root.state.cartaPresentacion).replace('&nbsp;', ''), 'text/html');
            let _v = (doc.body.innerHTML).replaceAll('<br>', '<br></br>');
            _root.props.pro.cartaPresentacion = `<html>
                                                <head>
                                                    <meta http-equiv='Content-Type' content='text/html; charset=UTF-8'/>
                                                    <style type='text/css'> 
                                                        * { font-family: 'Arial, Helvetica, sans-serif'; }
                                                    </style>
                                                </head>
                                                <body>
                                                    ${_v}
                                                </body>
                                            </html>
                                                
                                                `;
        }

        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/carta-presentacion'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);

        if(target == 'next') {
            if(!_root.state.has_file_s3) {
                var data = undefined;
                if(_root.state.isFilePicked){
                    var formdata = new FormData();
                    var json_request = {
                        "id": "",
                        "idSubmission": _root.props.pro.idSubmission,
                        "idTipo": "1",
                        "nombreArchivo": "",
                        "nombreArchivoS3": "",
                        "estado": ""
                    }
                    formdata.append("file", _root.state.file_selected);
                    formdata.append("request", JSON.stringify(json_request));
                 
                    ApiService.postDataFormData(`${APIS.documento}`, formdata) 
                        .then(res => {
                            // Tools.hidePreloader();
                            ApiService.postData(`${APIS.submission}`, _root.props.pro) 
                            .then(res => {
                                Tools.hidePreloader();
                                _root.props.process(_root.props.pro);
                                _root.props.general(_root.props.glo);
                                _root.props.navigate('/forma-pago');
                            })
                            .catch(err => { 
                                Tools.hidePreloader();
                                console.log(err); 
                            });
                            // _root.props.process(_root.props.pro);
                            // _root.props.general(_root.props.glo);
                            // _root.props.navigate('/forma-pago');
                        })
                        .catch(err => { 
                            Tools.hidePreloader();
                            console.log(err); 
                        });
                }else{
                    if(_root.state.itemFile !== null) {
                        ApiService.deleteData(`${APIS.documento}/${_root.state.itemFile.id}`)
                        .then(res => {
                            ApiService.postData(`${APIS.submission}`, _root.props.pro) 
                            .then(res => {
                                Tools.hidePreloader();
                                _root.props.process(_root.props.pro);
                                _root.props.general(_root.props.glo);
                                _root.props.navigate('/forma-pago');
                            })
                            .catch(err => { 
                                Tools.hidePreloader();
                                console.log(err); 
                            });
                        })
                        .catch(err => {
                            Tools.hidePreloader();
                        });
                    }
                    else {
                        ApiService.postData(`${APIS.submission}`, _root.props.pro) 
                        .then(res => {
                            Tools.hidePreloader();
                            _root.props.process(_root.props.pro);
                            _root.props.general(_root.props.glo);
                            _root.props.navigate('/forma-pago');
                        })
                        .catch(err => { 
                            Tools.hidePreloader();
                            console.log(err); 
                        });
                    }
                } 
            }
            else {
                if(_root.props.pro.cartaPresentacion != '') {
                    ApiService.postData(`${APIS.submission}`, _root.props.pro) 
                    .then(res => {
                        _root.props.process(_root.props.pro);
                        _root.props.general(_root.props.glo);
                        Tools.hidePreloader();
                        _root.props.navigate('/forma-pago');
                    })
                    .catch(err => { 
                        Tools.hidePreloader();
                        console.log(err); 
                    });
                }
                else {
                    Tools.hidePreloader();
                    _root.props.navigate('/forma-pago');
                }
            }
        }
        else if(target == 'download') {
            if(_root.props.pro.cartaPresentacion != '') {
                ApiService.postData(`${APIS.submission}`, _root.props.pro) 
                .then(res => {
                    _root.props.process(_root.props.pro);
                    _root.props.general(_root.props.glo);

                    ApiService.getDataFile(`${APIS.cartaPresentacionGenera}${_root.props.pro.idSubmission}`)
                    .then((rescp) => {
                        Tools.hidePreloader();
                        const blob = new Blob([rescp.data], { type: 'application/pdf' });
                        const objectUrl = window.URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = objectUrl;
                        link.download = `carta-presentacion.pdf`;

                        link.dispatchEvent(
                            new MouseEvent('click', { 
                                bubbles: true, 
                                cancelable: true, 
                                view: window 
                            })
                        );
                        setTimeout(() => {
                            window.URL.revokeObjectURL(objectUrl);
                            link.remove();
                        }, 100);
                    })
                    .catch((err) => {
                        Tools.hidePreloader();
                    });
                })
                .catch(err => { 
                    Tools.hidePreloader();
                });
            }
            else {
                Tools.hidePreloader();
            }
        }
    }
    
    render() {

        const {
            next_active,
            program_selected,
            show_editor,
            editor_disable,
            selectionRange,
            file_selected,
            maxLengthLetterText,
            maxLengthLetter,
            cartaPresentacion
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <>
            <div className="container">
                <div className="row app-layout-main">
                    <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                        { (program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'3'} form={program_selected.form} /> : <></> }
                    </div>
                    <div className="col-md-9 right-side-dashboard">
                        <TopProcessComponent porcent="60" />
                        <div className="row content-dashboard">
                            <div className="col-sm-12">
                                <div className="row pt-3 pb-3">
                                    <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/datos-laborales" /></div>
                                    <div className="col-sm-12 col-md-6"></div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <h5><strong>Carta de Presentación</strong></h5>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-8">
                                        <div className="form-check pb-2">
                                            <input className="form-check-input" type="checkbox" value="" id="no_work" />
                                            <label className="form-check-label" for="no_work">No me encuentro laborando</label>
                                        </div>
                                    </div> */}
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-9">
                                        <p><small>Queremos saber más de ti.</small></p>
                                        <p>
                                            <ul className="p-0">
                                                <li><small>Cuéntanos en una Carta de Presentación de 700 palabras aproximadamente lo siguiente:</small></li>
                                                <li><small><strong>¿Qué te motiva a llevar este Postgrado?</strong></small></li>
                                                <li><small><strong>¿Cuál es la razón por la que nos eliges?</strong></small></li>
                                                <li><small><strong>¿Qué competencias esperas obtener de este Postgrado?</strong></small></li>
                                                <li><small><strong>¿Cómo este Postgrado te acerca a tus objetivos Profesionales y Personales?</strong></small></li>
                                            </ul>
                                        </p>
                                        <p><small>El Comité de Admisión de la Escuela de Postgrado de la UTP estará atento a todos los detalles que puedas incluir para continuar con tu Proceso de Admisión.</small></p>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-9">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <button
                                                    // onClick={this.onClickLoadingWordOffice}  
                                                    className="btn btn-primary btn-style-7 position-relative">
                                                        <input type="file" name="file" className='btn-file-word' onChange={this.changeHandlerInputFile} />
                                                        Subir Carta de Presentación 
                                                        <img className="icon" src={UploadIcon} />
                                                        

                                                </button>
                                                <br/>
                                                {(show_editor == false)?
                                                    <>
                                                        <small><strong>Formato Word o PDF</strong></small>
                                                        {(file_selected != null)?
                                                            <p className='custom-presentacion-file'>
                                                                
                                                                <i class="fa fa-check-circle check-circle-verde" aria-hidden="true"></i>
                                                                { file_selected.name }
                                                                <i class="fa fa-trash-o trash-file-delete" aria-hidden="true" onClick={this.deletFilePresentation}></i>
                                                            </p>
                                                            : <></>
                                                        }
                                                    </>
                                                    :<></>
                                                }
                                                
                                            </div>
                                            <div className="col-sm-6">
                                                {/* <button 
                                                    className="btn btn-primary btn-style-7" 
                                                    onClick={this.onClickShowEditor} 
                                                    disabled={show_editor}>
                                                    Redactar Carta de Presentación 
                                                    <img className="icon" src={WriteIcon} />
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    (show_editor)
                                    ?
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-9">
                                            {/* <CKEditor
                                                config={ {
                                                    toolbar: {
                                                        items: [ 
                                                            'heading', '|',
                                                            'fontfamily', 'fontsize', '|',
                                                            'alignment', '|',
                                                            'fontColor', 'fontBackgroundColor', '|',
                                                            'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                                                            'link', '|',
                                                            'outdent', 'indent', '|',
                                                            'bulletedList', 'numberedList', 'todoList', '|',
                                                            'code', 'codeBlock', '|',
                                                            'insertTable', '|',
                                                            'undo', 'redo'
                                                        ],
                                                        shouldNotGroupWhenFull: true
                                                    }
                                                }}
                                                editor={ ClassicEditor }
                                                disabled={editor_disable}
                                                data={cartaPresentacion}
                                                onReady={ editor => {
                                                    this.setState({
                                                        editorCK: editor
                                                    });
                                                }}
                                                onChange={this.onChangeEditor}
                                                onBlur={this.onBlurEditor}
                                                onFocus={this.onFocusEditor}
                                                maxLength={maxLengthLetter}
                                            /> */}
                                            {/* <CKEditor
                                                config={{
                                                toolbar: [
                                                    { 
                                                        name: 'basicstyles', 
                                                        items: [ 
                                                            'Styles', 
                                                            'Format',
                                                            'Underline', 
                                                            'Italic', 
                                                            'Bold', 
                                                            'Font', 
                                                            'FontSize', 
                                                            'Undo', 
                                                            'Redo',
                                                            'NumberedList',
                                                            'BulletedList',
                                                            'JustifyLeft',
                                                            'JustifyCenter',
                                                            'JustifyRight',
                                                            'JustifyBlock',
                                                            'Table',
                                                            'Link',
                                                            'Unlink',
                                                            'Paste',
                                                            'PasteText',
                                                            'PasteFromWord'
                                                        ]
                                                    }
                                                ],
                                                removeButtons: 'Subscript,Superscript'
                                                }}
                                                // editor={ ClassicEditor }
                                                disabled={editor_disable}
                                                initData={cartaPresentacion}
                                                data={cartaPresentacion}
                                                onReady={ editor => {
                                                    this.setState({
                                                        editorCK: editor
                                                    });
                                                }}
                                                onChange={this.onChangeEditor}
                                                onBlur={this.onBlurEditor}
                                                onFocus={this.onFocusEditor}
                                                maxLength={maxLengthLetter}
                                            /> */}
                                            <span>{maxLengthLetterText}</span>
                                        </div>
                                        <div className="col-sm-12 col-md-9 mt-3" style={{textAlign: 'right'}}>
                                            <button type="button" class="btn btn-secondary btn-sm btn-style-4 gray" style={{marginRight: '10px'}} onClick={this.onClickDownloadLetter}>Descargar carta</button>
                                            <button type="button" class="btn btn-secondary btn-sm btn-style-4 gray" style={{marginRight: '10px'}} onClick={this.onClickHideEditor}>Cancelar</button>
                                            {/* <button type="button" class="btn btn-primary btn-sm btn-style-4">Enviar</button> */}
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4" style={{textAlign: 'right'}}>
                                        <button 
                                            className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'} 
                                            onClick={this.onClickNext}> 
                                            Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <DateRangePicker
                ranges={[selectionRange]}
                onChange={this.onChangeDateRange}
            /> */}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PresentationLetterPage);
// export default PresentationLetterPage;